export enum FLOW_TYPES {
  RESTAURANT = 'RESTAURANT',
  HOTEL = 'HOTEL',
}
